import React from "react"
import styled from "styled-components"
import { Icon } from "frontend/components/Icon/Icon"
import { parseAddress } from "QuorumGrassroots/widgets/ReusableComponents/UserInfoFormSection/helper"
import {
    ContainerWithColor,
    organizationPrimaryColor,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

const SuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
`

const Illustration = styled.div`
    svg {
        display: block;
        max-width: 100%;
        height: auto;
    }

    /* Use org primary color for accent strokes inside the SVG */
    .stroke-primary {
        stroke: var(--organization-primary-color-0);
    }
`

const Subtitle = styled.div`
    font-size: 14px;
    color: #495057;
`

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 28px;
    line-height: 32px;
    font-weight: 600;
    color: #000;

    .check-icon {
        color: #31b457;
    }
`

const AddressRow = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 20px;
    color: #495057;

    .pin-icon {
        color: #495057;
    }
`

export const VoterRegistrationSuccess: React.FC = () => {
    const addressCandidate = (window.userdata as any)?.address || (window.userdata as any)?.input_address
    const { addressText } = parseAddress(addressCandidate)

    return (
        <ContainerWithColor>
            <SuccessWrapper>
                <Illustration aria-hidden="true">
                    <svg width="292" height="160" viewBox="0 0 292 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M102.903 49.8386L75.1387 89.2852L80.7315 94.3333H191.543L216.026 50.4419L102.903 49.8386Z"
                            fill="url(#paint0_linear_911_5386)"
                        />
                        <path
                            d="M75.1387 89.2852L74.522 88.8511L74.1375 89.3974L74.6334 89.845L75.1387 89.2852ZM102.903 49.8386L102.907 49.0845L102.513 49.0824L102.287 49.4046L102.903 49.8386ZM216.026 50.4419L216.684 50.8093L216.03 49.6878L216.026 50.4419ZM191.543 94.3333V95.0875H191.986L192.202 94.7007L191.543 94.3333ZM80.7315 94.3333L80.2262 94.8932L80.4415 95.0875H80.7315V94.3333ZM75.1387 89.2852L75.7554 89.7192L103.52 50.2727L102.903 49.8386L102.287 49.4046L74.522 88.8511L75.1387 89.2852ZM102.903 49.8386L102.899 50.5928L216.022 51.1961L216.026 50.4419L216.03 49.6878L102.907 49.0845L102.903 49.8386ZM216.026 50.4419L215.367 50.0746L190.885 93.966L191.543 94.3333L192.202 94.7007L216.684 50.8093L216.026 50.4419ZM191.543 94.3333V93.5792H80.7315V94.3333V95.0875H191.543V94.3333ZM80.7315 94.3333L81.2368 93.7735L75.644 88.7253L75.1387 89.2852L74.6334 89.845L80.2262 94.8932L80.7315 94.3333Z"
                            fill="#808080"
                        />
                        <path d="M172.78 73.2847H116L118.768 67.2847H175L172.78 73.2847Z" fill="#808080" />
                        <path
                            d="M175.885 25.7059L170.003 71.8598H124L130.637 20.1252C145.096 23.0373 159.752 24.8786 174.482 25.634L175.885 25.7059Z"
                            fill="white"
                            stroke="#808080"
                            strokeWidth="1.5083"
                        />
                        <path
                            d="M134.862 48.5606L142.94 57.0457L165.013 35.9435"
                            stroke="#6CCF7D"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M173.623 25.8567L166.082 72.0105H169.852L176.187 26.3092L173.623 25.8567Z"
                            fill="#808080"
                        />
                        <path
                            d="M75 157.079V115.299V89.356L188.273 89.3561V157.079H75Z"
                            fill="url(#paint1_linear_911_5386)"
                            stroke="#808080"
                            strokeWidth="1.5083"
                        />
                        <path
                            d="M187.217 89.5069V157.079H216.93L216.567 50.1404L187.217 89.5069Z"
                            fill="url(#paint2_linear_911_5386)"
                            stroke="#808080"
                            strokeWidth="1.5083"
                            strokeLinejoin="bevel"
                        />
                        <path
                            d="M195.027 15.9019V26.3091"
                            stroke="#808080"
                            strokeWidth="1.5083"
                            strokeLinecap="round"
                        />
                        <path
                            d="M189.825 21.1069L200.232 21.1069"
                            stroke="#808080"
                            strokeWidth="1.5083"
                            strokeLinecap="round"
                        />
                        <path
                            d="M184.619 29.6274V36.8673"
                            stroke="#808080"
                            strokeWidth="1.04925"
                            strokeLinecap="round"
                        />
                        <path
                            d="M181 33.2483L188.24 33.2483"
                            stroke="#808080"
                            strokeWidth="1.04925"
                            strokeLinecap="round"
                        />
                        <path
                            d="M209.053 29.3257V34.7555"
                            stroke="#808080"
                            strokeWidth="0.786937"
                            strokeLinecap="round"
                        />
                        <path
                            d="M206.339 32.0415L211.769 32.0415"
                            stroke="#808080"
                            strokeWidth="0.786937"
                            strokeLinecap="round"
                        />
                        <path
                            d="M184.77 10.0195V13.9411"
                            stroke="#808080"
                            strokeWidth="0.568343"
                            strokeLinecap="round"
                        />
                        <path
                            d="M182.81 11.981L186.732 11.981"
                            stroke="#808080"
                            strokeWidth="0.568343"
                            strokeLinecap="round"
                        />
                        <path
                            d="M208.903 0.969727V4.8913"
                            stroke="#808080"
                            strokeWidth="0.568343"
                            strokeLinecap="round"
                        />
                        <path
                            d="M206.942 2.93115L210.864 2.93115"
                            stroke="#808080"
                            strokeWidth="0.568343"
                            strokeLinecap="round"
                        />
                        <path d="M287.78 157.38H4.22021" stroke="#808080" strokeWidth="1.5083" strokeLinecap="round" />
                        <path
                            d="M141.116 24.1903C134.763 18.0495 135.181 15.4362 130.975 7.93502L143.925 1.59166C144.468 3.48567 144.924 4.80552 147.04 7.37831C149.684 10.5943 156.843 10.0784 162.885 12.7954C167.719 14.969 170.311 20.7152 171.159 23.9508L162.837 23.2017C162.627 22.2196 161.588 20.4305 154.017 20.1974C151.623 20.1237 152.012 22.556 152.656 23.4807C157.503 27.5986 158.993 29.5325 159.131 29.9847C160.774 33.535 158.373 34.1616 156.967 34.0312C154.798 32.8958 152.657 31.318 150.424 29.9463C146.607 27.6016 142.905 25.4513 141.116 24.1903Z"
                            fill="url(#paint3_linear_911_5386)"
                            stroke="white"
                            strokeWidth="1.5083"
                        />
                        <g style={{ mixBlendMode: "overlay" }}>
                            <rect y="0.761719" width="292" height="159" fill={organizationPrimaryColor} />
                        </g>
                        <defs>
                            <linearGradient
                                id="paint0_linear_911_5386"
                                x1="157.5"
                                y1="6.5"
                                x2="157.5"
                                y2="85"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#808080" />
                                <stop offset="1" stopColor="white" />
                            </linearGradient>
                            <linearGradient
                                id="paint1_linear_911_5386"
                                x1="129"
                                y1="56.6182"
                                x2="129"
                                y2="134.118"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#808080" />
                                <stop offset="1" stopColor="white" />
                            </linearGradient>
                            <linearGradient
                                id="paint2_linear_911_5386"
                                x1="183.5"
                                y1="37.5"
                                x2="219.38"
                                y2="121.963"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#808080" />
                                <stop offset="1" stopColor="white" />
                            </linearGradient>
                            <linearGradient
                                id="paint3_linear_911_5386"
                                x1="163.553"
                                y1="38.7891"
                                x2="141.014"
                                y2="-15.1637"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#808080" />
                                <stop offset="1" stopColor="white" />
                            </linearGradient>
                        </defs>
                    </svg>
                </Illustration>

                <Subtitle>Here’s what our records show:</Subtitle>

                <TitleRow>
                    <Icon className="check-icon" icon="check-circle" iconFamily="fas" size="lg" />
                    <span>You are registered to vote!</span>
                </TitleRow>

                {addressText ? (
                    <AddressRow>
                        <Icon className="pin-icon" icon="map-marker-alt" iconFamily="far" />
                        <span>{addressText}</span>
                    </AddressRow>
                ) : null}
            </SuccessWrapper>
        </ContainerWithColor>
    )
}
